/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ModalWindow } from '../../../modal';
import { useClickController } from '../../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент подсказки в виде модального окна
 *
 * @export
 * @param {IInformationTooltipMobileProps} props
 * @returns
 */
export function InformationTooltipMobile(props) {
  var content = props.content,
    header = props.header,
    children = props.children,
    _props$portal = props.portal,
    portal = _props$portal === void 0 ? true : _props$portal;
  var _useClickController = useClickController(props),
    childrenProps = _useClickController.childrenProps,
    open = _useClickController.open,
    handleClose = _useClickController.handleClose;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/_jsx(ModalWindow, {
      open: open,
      onClose: handleClose,
      title: header,
      content: content,
      portal: portal
    })]
  });
}